export default __webpack_public_path__ + "static/media/RocketDAO-Experts@1x.891ccab7.png";